import React from 'react';
import useExportStacks from '@src/hooks/api/queries/modes/useExportStacks';
import useStackValidation from '@src/hooks/useStackValidation';
import QueryKeys from '@src/constants/queryKeys';
import { ImportControlModeTemplateResponseDto } from '@src/types/ControlModes';
import FileToolbar from '../../_shared/FileToolbar';
import useImportFile, { entityName } from '@hooks/api/mutations/useImportFile';

interface StacksToolbarProps {
  handleAdd: () => void;
  onImportSuccess?: (result: ImportControlModeTemplateResponseDto) => void;
  canEdit?: boolean;
}

export default function StacksToolbar({
  handleAdd,
  onImportSuccess,
  canEdit = true,
}: StacksToolbarProps): React.ReactElement {
  const { exportStacks, isExporting } = useExportStacks();
  const {
    importFile,
    isImporting,
    error: importApiError,
  } = useImportFile(entityName.STACKS);
  const validation = useStackValidation();

  return (
    <FileToolbar
      handleAdd={canEdit ? handleAdd : () => {}}
      importFile={canEdit ? importFile : async () => null}
      exportFile={exportStacks}
      queryKey={[QueryKeys.stacks]}
      entityName='STACK'
      validation={validation}
      importHook={{ isImporting, error: importApiError }}
      exportHook={{ isExporting }}
      onImportSuccess={onImportSuccess}
    />
  );
}
